import FullWidth from 'images/full-width.svg';
import InLine from 'images/in-line.svg';
import OpenInNewWindow from 'images/open-in-new-window.svg';

export const LEARNING_VALUES = {
  FULL_WIDTH: 'FullWidth',
  IN_LINE: 'InLine',
  NEW_WINDOW: 'NewWindow',
};

export const learningExperiences = [
  {
    title: t('questions.types.elearning.learning_experience_full_width'),
    img: FullWidth,
    value: LEARNING_VALUES.FULL_WIDTH,
    properties: {
      display_full_width: true,
      popout: false,
    },
  },
  {
    title: t('questions.types.elearning.learning_experience_in_line'),
    img: InLine,
    value: LEARNING_VALUES.IN_LINE,
    properties: {
      display_full_width: false,
      popout: false,
    },
  },
  {
    title: t('questions.types.elearning.learning_experience_popout'),
    img: OpenInNewWindow,
    value: LEARNING_VALUES.NEW_WINDOW,
    properties: {
      display_full_width: false,
      popout: true,
    },
  },
];
